export default __webpack_public_path__ + "static/media/Griefscale Boots.2099881d.jpg";